import React from "react";
import "sanitize.css";
import Slider from '@mui/material/Slider';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  {
    track: {
      color: "#455A23",
      height: "5px",
      borderRadius: "3px",
    },
    rail: {
      opacity: 1,
      backgroundColor: "#fff",
      border: "1px solid #455A23",
      height: "5px",
      borderRadius: "0px",
    },
    thumb: {
      color: "white",
      width: "17px",
      height: "17px",
      marginTop: "-1px",
      border: "2px solid #d9983e",
      boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.09)",
      "&$focusVisible,&:hover": {
        boxShadow: "0 0 0 8px rgba(41, 180, 184, 0.2)",
      },
      "&$active": {
        boxShadow: "0 0 0 14px rgba(41, 180, 184, 0.2)",
      },
    },
    focusVisible: {},
    active: {},
  },
  { name: "MuiSlider" }
);

export default function CMSSlider({ name, form, priceRange }) {
  const classes = useStyles();

  // fallback to priceRange if Formik value is undefined
  const value = form.values[name] || [priceRange.minValue, priceRange.maxValue];

  return (
    <div>
      <Slider
        classes={classes}
        step={5}
        min={priceRange.minValue}
        max={priceRange.maxValue}
        value={value}
        onChange={(ev, v) => form.setFieldValue(name, v)}
        valueLabelDisplay="off"
        aria-labelledby="range-slider"
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "5px 0",
          fontWeight: 500,
          color: "#455A23",
        }}
      >
        <div>{`${value[0]} AED`}</div>
        <div>{`${value[1]} AED`}</div>
      </div>
    </div>
  );
}
